import axios from "axios";
import * as API_LINKS from '../../config/links.js'
import {toast} from 'react-toastify'

export const FETCH_TRIPL_WINNER_TRACKER_LIST = 'FETCH_TRIPL_WINNER_TRACKER_LIST'
export const RECEIVE_TRIPL_WINNER_TRACKER_LIST = 'RECEIVE_TRIPL_WINNER_TRACKER_LIST'
export const FAILED_TRIPL_WINNER_TRACKER_LIST = 'FAILED_TRIPL_WINNER_TRACKER_LIST'

export function fetchTriPLWinnerTracker(_id_work_order){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_TRIPL_WINNER_TRACKER_LIST});
        axios({
            method: 'post',
            url: API_LINKS.TRIPL_BID_WINNER_TRACKER_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_work_order: _id_work_order
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_TRIPL_WINNER_TRACKER_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRIPL_WINNER_TRACKER_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRIPL_WINNER_TRACKER_LIST
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRIPL_WINNER_TRACKER_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRIPL_WINNER_TRACKER_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TRIPL_WINNER_TRACKER_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_TRIPL_WINNER_TRACKER_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}

export const FETCH_TRIPL_HISTORY_PATH_LIST = 'FETCH_TRIPL_HISTORY_PATH_LIST'
export const RECEIVE_TRIPL_HISTORY_PATH_LIST = 'RECEIVE_TRIPL_HISTORY_PATH_LIST'
export const FAILED_TRIPL_HISTORY_PATH_LIST = 'FAILED_TRIPL_HISTORY_PATH_LIST'

export function fetchTriPLHistoryPath(_days, _id_company){
    let bodyRequest = {
        type: "take",
        day: _days,
        id_company: _id_company
    }
    if(_id_company === "null"){
        delete bodyRequest["id_company"]; 
    }
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_TRIPL_HISTORY_PATH_LIST});
        axios({
            method: 'post',
            url: API_LINKS.TRIPL_HISTORY_LIST_PATH_URL,
            headers: {
                Authorization: auth
            },
            data: bodyRequest
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_TRIPL_HISTORY_PATH_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRIPL_HISTORY_PATH_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRIPL_HISTORY_PATH_LIST
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRIPL_HISTORY_PATH_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRIPL_HISTORY_PATH_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TRIPL_HISTORY_PATH_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_TRIPL_HISTORY_PATH_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}

export function updateTriPLHistoryPath(data){
    return (dispatch)=>{
        
            dispatch( {
                type: RECEIVE_TRIPL_HISTORY_PATH_LIST,
                payload: {result: [...data]}
            })
    }
}